import * as api from "../api"
import { IExpenseBundle, ITimecardEmployee, IUIUser, IUserDocument } from "../models"
import AppStateStore from "../stores/AppStateStore"
import strings from "../localization/strings"
import * as userHelper from "../helpers/userHelper"

export function addExpense(employee: IUserDocument | ITimecardEmployee | IUIUser, expenseBundle: IExpenseBundle, cb: (msg: string) => void) {
    if (!userHelper.checkLoggedInUserPermission(employee)) return
    AppStateStore.setProgressSnackbarContent("loading")
    api.addExpense(expenseBundle, userHelper.isESSAction(employee.Id))
        .then(() => {
            cb ?
                cb(strings.Successfully_created) :
                AppStateStore.setProgressSnackbarContent(strings.Successfully_created)
        })
        .catch(err =>
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
        )
}

export function updateExpense(employee: IUserDocument | ITimecardEmployee | IUIUser, expenseBundle: IExpenseBundle, cb: (msg: string) => void) {
    if (!userHelper.checkLoggedInUserPermission(employee)) return
    AppStateStore.setProgressSnackbarContent("loading")
    api.updateExpense(expenseBundle, userHelper.isESSAction(employee.Id))
        .then(() => {
            cb ?
                cb(strings.Successfully_updated) :
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
        })
        .catch(err =>
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
        )
}

export function deleteExpense(employee: IUserDocument | ITimecardEmployee | IUIUser, expenseIds: string[], cb: (msg: string) => void) {
    if (!userHelper.checkLoggedInUserPermission(employee)) return
    AppStateStore.setProgressSnackbarContent("loading")
    api.deleteExpenses(expenseIds, userHelper.isESSAction(employee.Id))
        .then(() => {
            cb ?
                cb(strings.Successfully_deleted) :
                AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
        })
        .catch(err =>
            AppStateStore.setProgressSnackbarContent(err.response.data.message)
        )
}